import { cn } from "../../../utils/cn";
import { DeleteRedIcon } from "../../screens/S-Cart/Cart.icons";
import { LocationIconFilled } from "../../screens/S-Pay/PayScreen.icons";
import styles from "./SavedLocationCard.module.scss";

interface SavedLocationCardProps {
  title: string;
  /** Secondary line shown below the title when the address is available */
  details?: string;
  isSelected?: boolean;
  /**
   * When false, renders the unavailable visual variant.
   * Defaults to true.
   */
  isAvailable?: boolean;
  /**
   * Shown in place of `details` when `isAvailable` is false.
   * If omitted while unavailable, the subtitle row is simply hidden.
   */
  unavailableText?: string;
  onSelect?: () => void;
  /**
   * Called when the delete icon is clicked.
   * stopPropagation is handled by the component — no need to do it in the callback.
   */
  onDelete: () => void;
  testId?: string;
  titleTestId?: string;
}

export const SavedLocationCard = ({
  title,
  details,
  isSelected = false,
  isAvailable = true,
  unavailableText,
  onSelect,
  onDelete,
  testId,
  titleTestId,
}: SavedLocationCardProps) => {
  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    onDelete();
  };

  return (
    <div
      className={cn(
        isAvailable ? styles.card : styles.card_unavailable,
        isSelected && styles.selected
      )}
      onClick={onSelect}
      data-testid={testId}
    >
      <div className={styles.top_row}>
        <div className={styles.content}>
          <LocationIconFilled shift={0} />
          <div className={styles.text_group}>
            <p className={styles.title} data-testid={titleTestId}>
              {title}
            </p>
            {isAvailable && details ? (
              <p className={styles.details}>{details}</p>
            ) : null}
          </div>
        </div>
        <span className={styles.delete} onClick={handleDelete}>
          <DeleteRedIcon />
        </span>
      </div>
      {!isAvailable && unavailableText ? (
        <p className={styles.subtitle_error}>{unavailableText}</p>
      ) : null}
    </div>
  );
};
